import { useCallback, useState } from 'react'
import {
  toggleSelection,
  withoutSelection,
} from '@sportninja/common/features/playerFinder/selection'

export interface PlayerFinderSelection {
  selectedIds: Set<string>
  isSelected: (id: string) => boolean
  toggle: (id: string) => void
  clear: () => void
  // Drops only these ids; the rest of the selection stays.
  deselect: (ids: Iterable<string>) => void
  count: number
}

export const usePlayerFinderSelection = (): PlayerFinderSelection => {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set())

  const toggle = useCallback((id: string) => {
    setSelectedIds((current) => toggleSelection(current, id))
  }, [])

  const clear = useCallback(() => setSelectedIds(new Set()), [])

  const deselect = useCallback((ids: Iterable<string>) => {
    setSelectedIds((current) => withoutSelection(current, ids))
  }, [])

  return {
    selectedIds,
    isSelected: (id: string) => selectedIds.has(id),
    toggle,
    clear,
    deselect,
    count: selectedIds.size,
  }
}
